import { createRef, useCallback, useState } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { filtruotiChip } from "../functions/filtruotiChip";
import StatistikaTable from "../Components/statistikaTable.js";
import { useStrapiObjectClass } from "../Hooks/useStrapiObject";
import isEqual from "lodash/isEqual";
import { useUrlParams } from "../Hooks/useUrlParams";

const Statistika = () => {
    const ref = createRef();

    const { t } = useTranslation()
    const [originalData, setOriginalData] = useState({ atsakymai: [], tipai: [] })
    const [tvarkyta, setTvarkyta] = useState([])
    const [isfiltruotiTipai, setIsfiltruotiTipai] = useState([])
    const { getAll: getAllAtsakymai, data: atsakymai } = useStrapiObjectClass({ name: 'atsakymai' });
    const { getAll: getAllObjectTipai, data: tipai } = useStrapiObjectClass({ name: 'formos' }, []);
    const { params: filters } = useUrlParams();

    useEffect(() => {
        const loadInitialData = async () => {
            await Promise.all([
                getAllAtsakymai(),
                getAllObjectTipai()
            ]);
        }
        loadInitialData()
    }, [getAllAtsakymai, getAllObjectTipai]);

    useEffect(() => {
        if (atsakymai.length > 0 && tipai.length > 0) {
            setOriginalData({ atsakymai, tipai });
        }
    }, [atsakymai, tipai])

    const filtrMain = useCallback(() => {
        if (!originalData.tipai.length || !originalData.atsakymai.length) {
            return;
        }

        const filteredTipai = originalData.tipai.filter(item => {
            return item.kasPildo === 'Darbuotojo forma';
        });
        setIsfiltruotiTipai(filteredTipai);

        const filteredAtsakymai = originalData.atsakymai.filter(item => {
            return item.kasPildo === 'Darbuotojo forma';
        });

        setTvarkyta(filteredAtsakymai);
    }, [originalData]);

    const filterChips = useCallback(() => {
        if (Object.keys(filters).length > 0) {
            const newTvark = filtruotiChip(tvarkyta, filters);
            if (newTvark && !isEqual(newTvark, tvarkyta)) {
                setTvarkyta(newTvark);
            }

        }
    }, [filters, tvarkyta])

    useEffect(() => {
        filtrMain();
    }, [filtrMain])

    useEffect(() => {
        filterChips();
    }, [filterChips])

    return (
        <div className="tendencijosCont stickyParent">
            <div className="standartPadding">
                <p className="rezTenName accorcionName">{t('statistika')}</p>
            </div>

            <div className={tvarkyta.length > 0 && isfiltruotiTipai.length > 0 ? "standartPadding bgBlue tendRezMargin" : "standartPadding bgBlue tendRezMargin"}>
                <div className="bgBlue pdfExport" ref={ref}>

                    {
                        atsakymai.length > 0 ?
                            <StatistikaTable
                                tipai={isfiltruotiTipai}
                                atsakymai={atsakymai} />
                            : <div className="neraAts">{ }</div>//t('Nera_atsakymu')
                    }
                </div>
            </div>
        </div>
    )
}
export default Statistika
